import { Table } from "antd";
import styled from "styled-components";
import { theme } from "../../../theme";

/**
 * 테이블 요약
 */
const SummaryText = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
  padding: 8px;

  ${theme.typo.body.r14};
`;

/**
 * 테이블 요약 강조
 */
const SummaryEm = styled.em`
  color: ${theme.colors.mainPrimary3};
  ${theme.typo.heading.b14};
`;

/**
 * 색없이 강조
 */
const SummarySubEm = styled.em`
  ${theme.typo.heading.b14};
  color: ${theme.colors.black};
`;

/**
 * 테이블 기본 스타일
 *
 */
const CustomTableStyled = styled(Table)`
  & .ant-table-container {
    border: 1px solid ${({ theme }) => theme.color.gray9};
    & .ant-table-thead > tr > th {
      text-align: center !important;
      ${theme.typo.heading.b14};
    }

    & .ant-table-expanded-row {
      &.noPad .ant-table-expanded-row-fixed {
        padding: 0;
      }

      & > .ant-table-cell {
        background-color: ${({ theme }) => theme.color.gray11};
      }
    }

    & .ant-table-row.highlight > .ant-table-cell {
      background: ${({ theme }) => theme.color.gray11};
    }
  }
  & .ant-table-footer {
    background: transparent;
  }
`;

/**
 * table cell anchor 표현
 */
const CellAnchor = styled.div`
  display: inline-flex;
  cursor: pointer;
  color: ${({ color }) => color || theme.colors.blue2};
  text-decoration: underline;

  &:hover {
    color: ${({ color }) => color || theme.colors.blue2};
    opacity: 0.8;
  }
`;

export { CellAnchor, CustomTableStyled, SummaryEm, SummarySubEm, SummaryText };
